import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/actionApiCallResponseStatusCodeActionMapping/paged', {
    params: toQuery(params),
  });
}

export async function queryEditItemResponseStatus({ id, params }) {
  return request(`/actionApiCallResponseStatusCodeActionMapping/${id}`, {
    params: toQuery(params),
  });
}

export async function queryAddNewResponseStatus(params) {
  return request.post(`/actionApiCallResponseStatusCodeActionMapping`, {
    data: params,
  });
}

export async function queryAddEditResponseStatus(params) {
  return request.put('/actionApiCallResponseStatusCodeActionMapping', {
    data: params,
  });
}

export async function queryDeleteItem(id) {
  return request.delete(`/actionApiCallResponseStatusCodeActionMapping/${id}`, {});
}
